import React from 'react';
import {
  Box,
  Card,
  Typography,
  IconButton,
  Tooltip,
  useTheme,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import SettingsIcon from '@mui/icons-material/Settings';
import useResponsive from '../hooks/useResponsive';

const Tile = ({ tile, handleTileClick, handleOpen, hideDescription }) => {
  const theme = useTheme();
  const { isMobileScreen } = useResponsive();

  const baseBackground =
    theme.palette.mode === 'dark'
      ? 'linear-gradient(180deg, rgba(44, 44, 46, 0.5) 10%, rgba(0, 0, 0, 0.5) 90%)'
      : 'linear-gradient(45deg, rgba(226, 226, 226, 0.5) 20%, rgba(255, 255, 255, 0.5) 90%)';

  const hoverBackground =
    theme.palette.mode === 'dark'
      ? 'rgba(68, 47, 87, 0.84)'
      : 'rgb(231, 247, 255)';

  return (
    <Box>
      <Card
        elevation={3}
        onClick={() => handleTileClick(tile.action)}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderRadius: 2,
          cursor: 'pointer',
          width: '100%',
          height: '100%',
          p: isMobileScreen ? 1 : 2.5,
          background: baseBackground,
          transition: 'background-color 0.3s ease, transform 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: hoverBackground
          },
        }}
      >
        {/* Tile Icon */}
        <Box
          sx={{
            width: '100px',
            height: '100px',
            mt: 2,
            '@media (max-width: 600px)': {
              margin: 0,
              padding: 1,
            },
          }}
        >
          {tile.icon || <InfoIcon />}
        </Box>

        {/* Title */}
        {!isMobileScreen && (
          <Typography variant="subtitle1" sx={{ pt: 3 }}>
            {tile.title}
          </Typography>
        )}

        {/* Optional Action Buttons (Info, Settings) */}
        {/* Uncomment if needed
        {!isMobileScreen && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              width: '100%',
              p: 0.5,
              opacity: 0,
              transition: 'opacity 0.3s ease',
              '&:hover': {
                opacity: 1,
              },
            }}
          >
            <Tooltip title="More Info">
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpen(tile);
                }}
                sx={{ color: theme.palette.grey[400] }}
              >
                <InfoIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Settings">
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  console.log(`Settings clicked for ${tile.title}`);
                }}
                sx={{ color: theme.palette.grey[400] }}
              >
                <SettingsIcon />
              </IconButton>
            </Tooltip>
          </Box>
        )}
        */}
      </Card>
    </Box>
  );
};

export default Tile;
